import { render, staticRenderFns } from "./NewWebpImageContainer.vue?vue&type=template&id=789afc9e&"
import script from "./NewWebpImageContainer.vue?vue&type=script&lang=js&"
export * from "./NewWebpImageContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports